import React, { Component } from 'react';

class FlashMessage extends Component {
  render() {
    const {
      optionalClasses,
      children
    } = this.props;

    return (
      <div className={`flash-message${optionalClasses ? ' ' + optionalClasses : ''}`}>
        {children}
      </div>
    )
  }
}

export default FlashMessage;



// WEBPACK FOOTER //
// ./src/components/Global/FlashMessage.js